import { render, staticRenderFns } from "./ReservationIcon.vue?vue&type=template&id=f0277e40&"
import script from "./ReservationIcon.vue?vue&type=script&lang=js&"
export * from "./ReservationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports